module.exports = __webpack_public_path__ + "static/media/wpr.6a5f89bc.svg";